var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/modules/_uid.js
// module id = 58
// module chunks = 48 49 50 51